
class ReadMore{
  constructor(options={}){
    this.options = options
    this.$section = options.sectionEl;
    this.$stateEl = options.stateEl || options.sectionEl
    this.$wysiwyg = options.wysiwygEl;
    this.$btn = options.buttonEl;

    if(!this.$section || !this.$wysiwyg || !this.$btn) {
      console.warn("Cannot Initilize Read More : Elements Missing")
      return
    }

    //Handling Animation Time
    if(options.animation){
      this.animationTime = typeof options.animation == 'number' ? parseFloat(options.animation) : 0.3
    }else{
      this.animationTime = 0
    }

    //Default Values
    this.limitDt = 0
    this.limitTbl = 0
    this.limitTbp = 0
    this.limitMb = 0

    this.lineCutMb = 0
    this.lineCutTb = 0
    this.lineCutDt = 0

    //Priortizing and overriding the default values
    const vals = ["limitDt", "limitTbl", "limitTbp", "limitMb", "lineCutMb", "lineCutTb", "lineCutDt"] 
    vals.forEach(val =>{
      if(Object.hasOwn(this.options, val)){
        this[val] = this.options[val]
        return
      }
      if(this.$section.dataset[val]){
        this[val] = parseInt(this.$section.dataset[val]) //!Check Null in this
        return
      }
    })


    //Getting Proiritized Active Devices Array or Function
    const activeDeviceString = this.$section.getAttribute("data-active-devices")
    this.activeDevicesArray = activeDeviceString ? activeDeviceString.split(",").map(item=>item.trim()) : []
    this.activeDevicesHtml = this.activeDevicesArray.length == 4 ? this.activeDevicesArray : [0,0,0,0] 
    this.activeDevices = options.activeDevices ? options.activeDevices : this.activeDevicesHtml

    this.linesLimit = this.#getCurrentLimit()
    this.lineCut = this.#getCurrentLineCut()

    this.isActive = false
    this.isDestroyed = true

    this.#setupStateProxy()
    this.init()
  }


  //Make this Method Public - VA
  init() {
    if(!this.state.isDestroyed) return
    this.state.isDestroyed = false

    this.#setupResizeHandler()
    this.$section.readMore = this
    !this.$stateEl.readMore && (this.$stateEl.readMore = this) //!Only For Normad - VA

    //Button Handler
    this.btnHandler = () => {
      this.$wysiwyg.getAttribute("aria-expanded") == "true" ?
        this.collapse() : this.expand();
    }
    this.$btn?.addEventListener("click", this.btnHandler)
    
    if(!this.#isActiveSize()){
      this.state.isActive = false
      return
    }

    //Ativates Readmore if in a active screen size
    this.activate()
  }


  expand(){
    if(!this.state.isActive) return
    this.emit("beforeExpand", {})
    this.$wysiwyg.style.height = this.expandedHeight + "px";
    this.state.isExpanded = true
    setTimeout(() => this.emit("afterExpand", {}), this.animationTime * 1000)
  }


  collapse(){
    if(!this.state.isActive) return
    this.emit("beforeCollapse", {})
    this.$wysiwyg.style.height = this.collapsedHeight + this.lineCut + "px";
    this.state.isExpanded = false
    setTimeout(() => this.emit("afterCollapse", {}), this.animationTime * 1000)
  }


  update(){
    if(this.state.isDestroyed || !this.#isActiveSize()) return
    this.activate()
    this.emit("update", {})
  }


  disable(){
    this.state.isActive = false
    this.state.isExpanded = true
    this.$wysiwyg.style.height = ""
  }


  activate(){
    this.linesLimit = this.#getCurrentLimit()
    this.lineCut = this.#getCurrentLineCut()

    this.$wysiwyg.style.height = ""

    this.expandedHeight = this.$wysiwyg.getBoundingClientRect().height;
    this.collapsedHeight = this.#calculateWysiwygHeight();

    if(!this.collapsedHeight){
      this.state.isActive = false;
      this.state.isExpanded = true
      this.$wysiwyg.style.height = ""
    }else{
      this.state.isActive = true;
      this.state.isExpanded = false
      this.$wysiwyg.style.height = this.collapsedHeight + this.lineCut + "px";
    }

    //Adding Animation
    if(this.animationTime){
      this.$wysiwyg.style.transition = `height ${this.animationTime}s ease-out`
    }
  }


  destroy(removeListeners=false) {

    this.emit("beforeDestroy", {})

    this.state.isActive = false
    this.state.isDestroyed = true;
    this.state.isExpanded = true

    this.$wysiwyg.style.height = ""
    this.$btn?.removeEventListener("click", this.btnHandler)
    this.$wysiwyg.classList.remove("read-more-expandad")


    this.isResizeHandlerEnabled = false
    window.removeEventListener("resize", this.resizeHandler)
    this.$section.readMore = null
    this.$stateEl.readMore && (this.$stateEl.readMore = null)

    this.emit("afterDestroy", {})

    if(removeListeners){
      //Remove attached listeners | event emitter
      this.events = null;
    }

    
  }


  #calculateWysiwygHeight(){
    if(this.linesLimit <= 0)return null
    const $children = Array.from(this.$wysiwyg.children)
    const wysiwygTop = this.$wysiwyg.getBoundingClientRect().top

    let currentHeight = 0
    let currentLines = 0

    for (const $child of $children) {
      const lineCount = this.#getLineCount($child);
      currentHeight = $child.getBoundingClientRect().top - wysiwygTop;

      if((lineCount + currentLines) > this.linesLimit){
        currentHeight += this.#percisionCutHeight($child, this.linesLimit - currentLines);
        return currentHeight
      }
      currentLines += lineCount
    }

    return null
  }


  #percisionCutHeight($el, lines){
    if(lines == 0) {
      const $prevChild = $el.previousElementSibling;
      if(!$prevChild) return -this.#getMargins($el).top

      const reduceAmount = this.#getMarginBetween($prevChild, $el) + this.#getPaddings($prevChild).bottom
      return -reduceAmount
    }

    const paddingTop = this.#getPaddings($el).top
    const lineHeight = this.#getLineHeight($el)
    return (lineHeight * lines) + paddingTop 
  }


  #getLineCount($el){
    const padding = this.#getPaddings($el).total
    const height = this.#getHeight($el)
    const lineHeight = this.#getLineHeight($el)
    return Math.round((height - padding) / lineHeight)
  }

  //Helper Functions -----------------------------------------------------------

  #getPaddings($el){
    const computedStyles = window.getComputedStyle($el);
    const paddingTop = parseFloat(computedStyles.paddingTop)
    const paddingBottom = parseFloat(computedStyles.paddingBottom)

    return {
      top: paddingTop, 
      bottom: paddingBottom,
      total: paddingTop + paddingBottom
    }
  }

  #getMargins($el){
    const computedStyles = window.getComputedStyle($el);
    const marginTop = parseFloat(computedStyles.marginTop)
    const marginBottom = parseFloat(computedStyles.marginBottom)

    return {
      top: marginTop, 
      bottom: marginBottom,
      total: marginTop + marginBottom
    }
  }

  #getMarginBetween($el1, $el2) {
    const prevElMb = this.#getMargins($el1).bottom
    const currentElMt = this.#getMargins($el2).top
    const finalMargin = currentElMt > prevElMb ? currentElMt : prevElMb
    return finalMargin
  }


  #getHeight($el){
    const rect = $el.getBoundingClientRect();
    return rect.height;
  }


  #getLineHeight($el){
    const computedStyles = window.getComputedStyle($el);
    if(!parseFloat(computedStyles.lineHeight)){
      $el.style.lineHeight = 1.15
    }
    return parseFloat(computedStyles.lineHeight)
  }

  #getCurrentLimit(){
    const width = window.innerWidth;
    let limit = this.limitMb
    
    if(width > 1199){
      limit = this.limitDt
    }else if(width > 991){
      limit = this.limitTbl
    }else if(width > 767){
      limit = this.limitTbp
    }
    return limit
  }


  #getCurrentLineCut(){
    const width = window.innerWidth;
    let lineCut = this.lineCutMb
    
    if(width > 1199){
      lineCut = this.lineCutDt
    }else if(width > 767){
      lineCut = this.lineCutTb
    }
    return lineCut
  }


  #isActiveSize(){
    if(typeof this.activeDevices === 'function'){
      return this.activeDevices()
    }

    //If user doesn't pass the active sizes then get it from the html attribute or default value
    const devices = this.activeDevices
    const size = window.innerWidth
    let state = false

    if(size < 768) {
      state = devices[0] == '1'
    }else if(size < 992) {
      state = devices[1] == '1'
    }else if(size < 1200) {
      state = devices[2] == '1'
    }else {
      state = devices[3] == '1'
    }
    return state
  }


  #setupResizeHandler(){
    if(this.isResizeHandlerEnabled) return

    let initialWidth = window.innerWidth

    this.resizeHandler = () => {
      if (window.innerWidth == initialWidth) return
      initialWidth = window.innerWidth;

      if(!this.#isActiveSize() && this.state.isActive){
        this.disable()
        return
      }else if (this.#isActiveSize() && !this.state.isActive){
        this.activate()
      }else if(this.#isActiveSize()){
        this.update()
      }
    }

    window.addEventListener("resize", this.resizeHandler)
    this.isResizeHandlerEnabled = true
  }


  //Manage States and Corresponding data attributes in the class ---------------
  #setupStateProxy(){
    const readMoreStatus = {
      isActive: {attr: "data-readmore-active", state: false},
      isDestroyed: {attr: "data-readmore-destroyed", state: true},
      isExpanded: {attr: "data-readmore-expanded", state: false}
    }

    //Initially Adding All Attributes to the Element
    for (const key in readMoreStatus) {
      if (readMoreStatus.hasOwnProperty(key)) {
        this.$stateEl.setAttribute(readMoreStatus[key].attr, readMoreStatus[key].state)
      }
    }

    // Proxy Handler for the "swiperStatus" Object
    const statusHandler = {
      get: (target, prop)=>{
        return target[prop].state;
      },

      set: (target, prop, value)=>{
        if(!target[prop] && value.attr){
          target[prop] = {attr: value.attr, state: value.state ? value.state : ""};
        }else if(target[prop]){
          target[prop].state = value;
        }else{
          return false
        }

        //Update Handlers
        this.$stateEl.setAttribute(target[prop].attr, target[prop].state)
        prop == "isExpanded" && this.$wysiwyg.setAttribute("aria-expanded", target[prop].state)
        return true;
      },

      deleteProperty: (target, prop)=>{
        this.$stateEl.removeAttribute(target[prop].attr)
        delete target[prop];
        return true
      }
    }

    this.state = new Proxy(readMoreStatus, statusHandler);
  }


  //Event Emmiter Realted Code -------------------------------------------------

  /**
   * on
   * Description: Regiter new callbacks for the given eventName
   * @param {string} eventName - Event Name.
   * @param {function} listener - Callback to run when event triggers.
   */
  on(eventName, listener){
    if (!this.events) this.events = {};
    if(!this.events[eventName]){
      this.events[eventName] = []
    }
    this.events[eventName].push(listener)
  }


  /**
   * off
   * Description: Remove the given callback for the event from callbacks array.
   * @param {string} eventName - Event Name.
   * @param {function} listener - function to remove.
   */
  off(evenetName, listener){
    const listeners = this.events?.[evenetName]
    if(listeners){
      const index = listeners.indexOf(listener)
      if(index !== -1){
        listeners.splice(index,1)
      }
    }
  }


  /**
   * emit
   * Description: Calls all registed callbacks for the events with given args
   * @param {string} eventName - Event Name.
   * @param {any} args - arguments to pass to tha callback.
   */
  emit(eventName, ...args){
    const listeners = this.events?.[eventName]
    if(listeners){
      listeners.forEach(listener => {
        listener.apply(null, args)
      })
    }
  }

}

export default ReadMore;
